// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1sMY7","col":"styles_col__1T1pf","fulfillmentStatus":"styles_fulfillmentStatus__1CMBs","emailCol":"styles_emailCol__36yM2"};